import { Users, Play, Star, Clock, GraduationCap, X, Info } from "lucide-react";
import React, { useState } from "react";
import { Link } from "react-router-dom";

export const GameCard = ({ game }) => {
  const [showMathInfo, setShowMathInfo] = useState(false);

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case "Easy":
        return "text-green-600 bg-green-100";
      case "Medium":
        return "text-yellow-600 bg-yellow-100";
      case "Hard":
        return "text-red-600 bg-red-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  return (
    <>
      <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 relative flex flex-col h-full">
        {game.featured && (
          <div className="absolute top-4 right-4">
            <Star className="h-5 w-5 text-yellow-500 fill-current" />
          </div>
        )}
        <h3 className="text-xl font-semibold mb-2 text-gray-800">{game.name}</h3>
        <p className="text-gray-600 mb-4 flex-grow">{game.description}</p>
        <div className="space-y-2 mb-4">
          <div className="flex items-center justify-between">
            <span
              className={`px-2 py-1 rounded-full text-xs font-medium ${getDifficultyColor(
                game.difficulty
              )}`}
            >
              {game.difficulty}
            </span>
            <div className="flex items-center text-sm text-gray-500">
              <Users className="h-4 w-4 mr-1" />
              {game.players}
            </div>
          </div>

          <div className="flex items-center text-sm text-gray-500">
            <Clock className="h-4 w-4 mr-1" />
            {game.duration}
          </div>
        </div>
        <div className="flex flex-wrap gap-1 mb-4">
          {game.tags.map((tag) => (
            <span
              key={tag}
              className="px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded"
            >
              {tag}
            </span>
          ))}
        </div>
        
        {game.mathConcept && (
          <button 
            onClick={() => setShowMathInfo(true)}
            className="mb-4 text-sm text-indigo-700 bg-indigo-50 px-3 py-2 rounded-md flex items-center w-full hover:bg-indigo-100 transition-colors group text-left"
            title="Click to learn more about the math behind this game"
          >
              <GraduationCap className="h-4 w-4 mr-2 flex-shrink-0 group-hover:scale-110 transition-transform" />
              <div className="flex-grow">
                  <div className="text-xs text-indigo-500 uppercase font-bold tracking-wider">Math Concept</div>
                  <div className="font-medium flex items-center justify-between">
                     {game.mathConcept}
                     <Info className="h-4 w-4 opacity-50 group-hover:opacity-100" />
                  </div>
              </div>
          </button>
        )}

        <Link
          to={`/games/${game.id}`}
          disabled={game.comingSoon}
          className={`w-full py-2 px-4 rounded-lg font-medium transition-colors flex items-center justify-center mt-auto
        ${
          game.comingSoon
            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
            : "bg-blue-500 text-white hover:bg-blue-600"
        }`}
        >
          {game.comingSoon ? (
            "Coming Soon"
          ) : (
            <>
              <Play className="h-4 w-4 mr-2" />
              Play Now
            </>
          )}
        </Link>
      </div>

      {/* Modal / Dialog for Math Concept */}
      {showMathInfo && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-fade-in" onClick={() => setShowMathInfo(false)}>
              <div 
                className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 relative transform transition-all scale-100" 
                onClick={e => e.stopPropagation()}
              >
                  <button 
                    onClick={() => setShowMathInfo(false)}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                  >
                      <X className="h-5 w-5" />
                  </button>
                  
                  <div className="flex items-center mb-4 text-indigo-600">
                      <div className="p-2 bg-indigo-100 rounded-lg mr-3">
                          <GraduationCap className="h-6 w-6" />
                      </div>
                      <h3 className="text-xl font-bold text-gray-900">Math Concept</h3>
                  </div>
                  
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">{game.mathConcept}</h4>
                  
                  <p className="text-gray-600 leading-relaxed mb-6">
                      {game.mathConceptDescription || "This game helps develop critical thinking and problem-solving skills related to this concept."}
                  </p>
                  
                  <div className="flex justify-end">
                      <button 
                        onClick={() => setShowMathInfo(false)}
                        className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors font-medium"
                      >
                          Got it!
                      </button>
                  </div>
              </div>
          </div>
      )}
    </>
  );
};
